module.exports = __webpack_public_path__ + "static/media/4.41c72cb1.jpg";